module.exports = __webpack_public_path__ + "img/图片7.eb5d57d1.png";